import { getBgColor } from "@/src/helpers";
import { MainSection } from "@/styles/global";
import React from "react";
import S from "./ContactBlock.styled";
import PhoneIcon from "@/assets/phone.svg";
import MailIcon from "@/assets/mail.svg";
import FacetimeIcon from "@/assets/facetime.svg";

export type ContactBlockProps = {
  title: string;
  text: string;
  contacts: {
    value: string;
    label: string;
    type: string;
  }[];
  backgroundColor: string;
};

const ContactBlock: React.FC<ContactBlockProps> = ({
  title,
  text,
  contacts,
  backgroundColor,
}) => {
  const renderContacts = contacts?.map(({ value, label, type }, index) => {
    const renderType = () => {
      if (type === "mail") {
        return (
          <S.ContactLink
            href={`mailto:${label}`}
            key={index}
            $bgColor={backgroundColor}
          >
            <MailIcon />
            {label}
          </S.ContactLink>
        );
      } else if (type === "phone") {
        return (
          <S.ContactLink
            href={`tel:${label}`}
            key={index}
            $bgColor={backgroundColor}
          >
            <PhoneIcon />
            {label}
          </S.ContactLink>
        );
      } else if (type === "facetime") {
        return (
          <S.ContactLink
            href={`tel:${label}`}
            key={index}
            $bgColor={backgroundColor}
          >
            <FacetimeIcon />
            {label}
          </S.ContactLink>
        );
      }
      return <S.ContactText key={index}>{label}</S.ContactText>;
    };

    return (
      <S.Contact key={index} $bgColor={backgroundColor}>
        <S.ContactTitle>{value}</S.ContactTitle>
        {renderType()}
      </S.Contact>
    );
  });

  return (
    <MainSection>
      <S.Inner>
        <S.Container $bgColor={getBgColor("dark", backgroundColor)}>
          <S.TextWrapper>
            {title && <S.Title $bgColor={backgroundColor}>{title}</S.Title>}
            {text && <S.Text $bgColor={backgroundColor}>{text}</S.Text>}
          </S.TextWrapper>
          <S.ContactsWrapper $bgColor={backgroundColor}>
            {renderContacts}
          </S.ContactsWrapper>
        </S.Container>
      </S.Inner>
    </MainSection>
  );
};

export default ContactBlock;
